module.exports = __webpack_public_path__ + "img/stockholm-header.baacdb74.png";